import { cn } from '#client/lib/cn';

interface SkeletonProps {
  /** Any CSS length. Defaults to filling the container. */
  width?: string | undefined;
  height?: string | undefined;
  className?: string | undefined;
}

/**
 * A placeholder block shaped like the content that is coming.
 *
 * Skeletons beat spinners wherever the layout is already known — a table body,
 * a detail pane, a form — because they preserve the page's shape and so read
 * as roughly 30% faster. They only work if they *mirror* the real layout,
 * though: the right number of rows, the right column widths. A generic grey
 * rectangle is worse than nothing.
 *
 * Spinners stay for atomic blocking actions (a submitting button, a rendering
 * PDF) where there is no layout to mirror.
 */
export function Skeleton({ width, height = '0.75rem', className }: SkeletonProps) {
  return (
    <span
      className={cn('c-skeleton', className)}
      style={{ width: width ?? '100%', height }}
      // Purely decorative: the table announces its own loading state through a
      // live region, so a screen reader must not read a wall of placeholders.
      aria-hidden="true"
    />
  );
}
